<template>
  <div v-if="cashflow">
    <v-select
      label="Change cashflow"
      v-model="cashflow.id"
      :items="cashflows"
      item-value="id"
      item-text="name"
      @change="update"
      outline
    />
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "CashflowSelect",
  data() {
    return { cashflow: null, cashflows: null };
  },
  methods: {
    fetchCashflow() {
      nbmlaw
        .get(`/cors/admin/directory/entities/current/cashflows/current`)
        .then(response => {
          //   console.log(response.data);
          this.cashflow = response.data;
        })
        .catch(() => {});
    },
    fetchCashflows() {
      nbmlaw
        .get(`/cors/admin/directory/entities/current/cashflows`)
        .then(response => {
          //   console.log(response.data);
          this.cashflows = response.data;
        })
        .catch(() => {});
    },
    update() {
      nbmlaw
        .put(`/cors/admin/directory/entities/current/cashflows/current`, {
          theInteger: this.cashflow.id
        })
        .then(() => {
          //   console.log(response.data);
          this.$emit("updated");
          this.fetchAll();
        })
        .catch(() => {});
    },
    fetchAll() {
      this.fetchCashflow();
      this.fetchCashflows();
    }
  },
  created() {
    this.fetchAll();
  }
};
</script>
